import { Validator } from 'fluentvalidation-ts';
import { IMealCountKey } from '@/models';
import moment from 'moment';

export class MealCountVersionValidator extends Validator<IMealCountKey> {
  constructor() {
    super();

    this.ruleFor('mealTypeId')
      .notEmpty()
      .withMessage('Please enter your a serving type');

    this.ruleFor('siteId')
      .greaterThan(0)
      .withMessage('Must select a site');

    this.ruleFor('programId')
      .notEmpty()
      .withMessage('Must select a program');

    this.ruleFor('mealServiceDate')
      .must((v, m) => {
        return moment(v) < moment();
      })
      .withMessage('You may not serve in the future');
  }
}
